import styled, { css } from 'styled-components';

export const StyledContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px;
  `}
`;

export const Image = styled.img`
  max-width: 200px;
  width: 100%;
`;

export const TitleRow = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-width: 100%;
    padding: 24px 24px 40px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 0px;
  `}
`;

export const Content = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 100%;
    min-width: 100%;
    margin: 72px 0px 0px;
`;

export const HeaderRightColumn = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
`;

export const SelectWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    & > div {
      padding: 0px;
      border: 0px;
      & > div {
        padding: 0px;
      }
    }
`;

export const SecondTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.menuPrimaryDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
    max-width: 364px;
    text-align: center;
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 8px 0px 0px;
    text-align: center;
  `}
`;


export const CardWrapper = styled.div`
    ${({ theme }) => css`
      border-radius: 16px;
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 32px;
      padding: 32px;
      margin: 32px 0px 0px;
    `}
`;

export const CardColumn = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;

export const CardImage = styled.img`
    width: 100%;
    max-width: 267px;
    height: 100%;
    max-height: 281px;
`;

export const PostDescriptionLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 12px 0px 0px;
    text-align: center;
    padding: 0px 16px;
    text-align: left;
  `}
`;

export const Separator = styled.div`
    ${({ theme }) => css`
      background-color: ${theme.v2.colors.neutral.highMedium};
      height: 1px;
      width: 100%;
      margin: 12px 0px 0px;
    `}
`;

export const SeparatorWithoutMargin = styled(Separator)`
    margin: 0px;
`;

export const IconsRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
    margin: 12px 0px 12px;
    padding: 0px 16px;
    align-items: center;
    justify-content: flex-start;
`;

export const PostCard = styled.div`
    ${({ theme }) => css`
      border-radius: 16px;
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      max-width: 267px;
      padding: 16px 0px 0px;
      align-items: flex-start;
    `}
`;

export const ItemRowContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 8px;
`;

export const ItemRowContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 2px;
`;

export const ItemRowLabel = styled.span`
  ${({ theme }) => css`
    width: 100%;
    max-width: 292px;
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ItemRowInfo = styled.div`
    display: flex;
    gap: 8px;
`;

export const ItemRowInfoText = styled.span`
  ${({ theme }) => css`
    width: 100%;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const PostDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Tag = styled.span`
    ${({ theme }) => css`
      border-radius: 4px;
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.medium};
      line-height: ${theme.v2.font.lineHeight.text};
      padding: 1px 8px;
      width: fit-content
    `}
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
`;
